import ChartTab from "./ChartTab";
import React from "react";
import computeDefaultTableSize from "../../tools/computeDefaultTableSize";
class ChartProjectTabPure extends React.Component {
  render() {
    const { data } = this.props;

    let pivots = ["project", "tiers", "category"];
    let showColumns = ["project", "tiers", "category", "hiddenSeller"];

    if (
      this.props.showProductColumn === undefined ||
      this.props.showProductColumn === true
    ) {
      //show product by default
      pivots.push("product");
      showColumns.push("product");
    }

    return (
      <ChartTab
        {...this.props}
        data={data}
        defaultPageSize={computeDefaultTableSize(data, "project")}
        pivots={pivots}
        showColumns={showColumns}
        showPagination={false}
        showDetails={true}
        showExtra={true}
        defaultSorted={[
          {
            id: "project",
            desc: false
          }
        ]}
      />
    );
  }
}

export default ChartProjectTabPure;
